import React, { memo } from 'react';
import classNames from 'classnames';
import cls from '../Calculations.module.css';
import { Input } from '../../../../../../components/newUI/Input/Input';

export const Doors = memo(({ isManualCalculations, onInput, calculations, manualCalculations }) => {
    return (
        <div className={classNames(cls)}>
            <h3 className={cls.subBlockHeader}>{i18next.t('Doors.return.subBlockHeader')}</h3>
            <div className={cls.columns}>
                <Input
                    type={'measurements'}
                    inputName={'door_quantity'}
                    onChange={onInput}
                    value={
                        (!isManualCalculations ? calculations : manualCalculations).door_quantity
                    }
                    classes={cls.column}
                    placeholder={0}
                    label={i18next.t('Doors.return.input.doorQuantityLabel')}
                    isDisabled={!isManualCalculations}
                />
                <Input
                    type={'measurements'}
                    inputName={'door_area'}
                    onChange={onInput}
                    value={(!isManualCalculations ? calculations : manualCalculations).door_area}
                    classes={cls.column}
                    placeholder={0}
                    label={i18next.t('Doors.return.input.doorAreaLabel')}
                    isDisabled={!isManualCalculations}
                />
                <Input
                    type={'measurements'}
                    inputName={'door_perimeter'}
                    onChange={onInput}
                    value={
                        (!isManualCalculations ? calculations : manualCalculations).door_perimeter
                    }
                    classes={cls.column}
                    placeholder={0}
                    label={i18next.t('Doors.return.input.doorPerimeterLabel')}
                    isDisabled={!isManualCalculations}
                />
            </div>
            <div className={cls.columns}>
                <Input
                    type={'measurements'}
                    inputName={'door_slope_area'}
                    onChange={onInput}
                    value={
                        (!isManualCalculations ? calculations : manualCalculations).door_slope_area
                    }
                    classes={cls.column}
                    placeholder={0}
                    label={i18next.t('Doors.return.input.doorSlopeAreaLabel')}
                    isDisabled={!isManualCalculations}
                />
                <Input
                    type={'measurements'}
                    inputName={'door_slope_perimeter'}
                    onChange={onInput}
                    value={
                        (!isManualCalculations ? calculations : manualCalculations)
                            .door_slope_perimeter
                    }
                    classes={cls.column}
                    placeholder={0}
                    label={i18next.t('Doors.return.input.doorSlopePerimeterLabel')}
                    isDisabled={!isManualCalculations}
                />
            </div>
        </div>
    );
});
